import React, { useLayoutEffect, useState } from "react";
import { Avatar, Box, IconButton, Stack, Typography } from "@mui/material";
import { Images } from "./../../assets/common";
import { fullName, screenWidth, truncate } from "../../constants/function";
import AIBadge from "../AIBadge";

/**
 * Top row of the mobile (<768px) player bar: artwork, title/artists, and the
 * repeat, queue, add-to-studio and tip buttons. The transport row below it is
 * WaveSurferPlayer's "mobile" variant. Markup and sizes match the bar as it
 * was before the desktop redesign; keep them in sync with each other.
 */
export default function MobileNowPlaying({
  song,
  repeat,
  repeatLabel,
  onRepeat,
  queueLabel,
  queueButtonRef,
  onToggleQueue,
  addLabel,
  onAddToStudio,
  canTip,
  onTip,
  onOpenSong,
  onOpenArtist,
  onOpenUploader,
}) {
  const [size, setSize] = useState();
  useLayoutEffect(() => {
    function updateSize() {
      setSize(screenWidth());
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <Stack direction="row" className="__player_box_top">
      <Stack
        className="__player_box_top_left"
        sx={{ justifyContent: "flex-start" }}
        direction="row"
      >
        <Avatar
          sx={{
            marginRight: "10px",
            height: "30px",
            width: "30px",
          }}
          src={song["thumbnailImg"] ? song["thumbnailImg"]["filePath"] : Images.rectangle}
        />
        <Stack direction="column" marginRight="auto">
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Typography
              title={song["title"]}
              variant="body1"
              style={{ width: "max-content", fontSize: "0.9rem" }}
              color="primary"
              className="_cp text-capitalize"
              onClick={onOpenSong}
            >
              {size < 600
                ? truncate(song["title"], 15)
                : size > 600
                ? truncate(song["title"], 25)
                : song["title"]}
            </Typography>
            <AIBadge show={song["isAIGenerated"]} size="small" />
          </Stack>
          <Stack
            direction="row"
            className="__artist_name"
            style={{
              overflowY: "scroll",
              width: "120px",
              gap: "5px",
            }}
          >
            {song?.artistData ? (
              song.artistData.map((a, aIndex) => (
                <Typography
                  variant="body2"
                  className="_cp"
                  onClick={() => onOpenArtist(a.uId)}
                  key={aIndex}
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: ".725rem",
                  }}
                >
                  {a?.displayArtistName}
                  {song.artistData.length > 1 && aIndex < song.artistData.length - 1 ? "," : ""}
                </Typography>
              ))
            ) : (
              <Typography variant="body2" className="_cp" onClick={onOpenUploader}>
                {size < 600
                  ? truncate(fullName(song["artist"] ? song["artist"] : song["uploader"]), 9)
                  : fullName(
                      song["artist"]
                        ? song["artist"]
                        : typeof song["uploader"] === "object"
                        ? song["uploader"]
                        : ""
                    )}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
      <Stack
        className="__player_box_top_right"
        sx={{ justifyContent: "flex-end" }}
        alignItems="center"
        direction="row"
      >
        <IconButton onClick={onRepeat} title={repeatLabel} aria-label={repeatLabel}>
          <img
            src={
              repeat === 2 ? Images.repeat_one : repeat === 1 ? Images.repeat_active : Images.repeat
            }
            alt="repeat"
            className="w24 h24"
            style={{
              opacity: repeat > 0 ? 1 : 0.6,
            }}
          />
        </IconButton>
        <Box sx={{ position: "relative", display: "flex" }}>
          <IconButton ref={queueButtonRef} title={queueLabel} onClick={onToggleQueue}>
            <img src={Images.white_stream} alt="" className="w24 h24" />
          </IconButton>
          <IconButton title={addLabel} onClick={onAddToStudio}>
            <img src={Images.playlist_add} alt="add to studio" className="w24 h20" />
          </IconButton>
        </Box>
        {canTip ? (
          <Stack
            direction="row"
            alignItems="center"
            gap="5px"
            padding="8px"
            onClick={onTip}
            className="_cp"
            title="Tip song"
          >
            <img style={{ width: "24px" }} src={Images.tip_player} alt="tip_player" />
          </Stack>
        ) : null}
      </Stack>
    </Stack>
  );
}
